// The two tabs of สรุปรอบเข้าเยี่ยมร้าน. Each tab owns its own path so their query-string state
// never mixes and the browser's back button walks between them.

export const VISIT_FREQUENCY_PATH = "/report/visit-frequency";

/** A child of the menu's own path, so the sidebar keeps the menu highlighted on this tab. */
export const INACTIVE_STORES_PATH = "/report/visit-frequency/inactive-stores";
